import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Empresa} from '../models';
import {ApiService} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService extends ApiService<Empresa> {
  protected objectKey = 'Empresas';
  protected dataKey = 'empresas';

  constructor(protected httpClient: HttpClient) {
    super(Empresa, httpClient, 'apiSeguroUrl');
  }
}
